module.exports = __webpack_public_path__ + "static/media/qr_code.5ef3db87.png";